if (!customElements.get('newsletter-form')) {
  customElements.define(
    'newsletter-form',

    class newsletterForm extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('.input-contact');
        this.containerMessages = this.querySelector('.message');
        this.submitBtn = this.querySelector('button[type="submit"]');
        this.form = this.querySelector('form');

        this.input.addEventListener('input', () => {
          if (this.input.checkValidity()) {
            this.submitBtn.disabled = false;
            this.submitBtn.classList.remove('button-disable');
          } else {
            this.submitBtn.disabled = true;
            this.submitBtn.classList.add('button-disable');
          }
        });

        this.form.addEventListener('submit', (e) => {
          e.preventDefault();

          this.disabledContent();

          const form = this.form;
          const formData = new FormData(form);

          this.containerMessages.innerHTML = '';
          const span = document.createElement('span');

          fetch(`${window.internalApi.baseUrl}/users/subscribe`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              email: formData.get('email'),
            }),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.containerMessages.classList.add('warning-block');
                span.innerHTML = 'Email already registered. Please enter a new one.';
                this.input.classList.add('form-error-footer');
                this.form.classList.add('form-error-footer');
              } else {
                this.containerMessages.classList.add('info-block');
                span.innerHTML = 'Thanks for joining!';
                const errorExist = this.input.classList.contains('form-error-footer');

                errorExist ? this.input.classList.remove('form-error-footer') : ''
              }

              this.containerMessages.appendChild(span);
            })
            .catch((response) => {
              span.innerHTML = response.message;
              this.containerMessages.appendChild(span);
              this.containerMessages.classList.add('warning-block');
              this.input.classList.add('form-error-footer');
            })
            .finally(() => {
              this.containerMessages.classList.remove('hidden');
              this.enableContent();
              this.form.reset();
            });
        });
      }

      disabledContent() {
        this.style.opacity = '0.4';
        this.style.pointerEvents = 'none';
        this.containerMessages.classList.add('hidden');
      }

      enableContent() {
        this.style.opacity = '1';
        this.style.pointerEvents = 'auto';
      }
    },
  );
}
